"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const context_1 = require("context");
const actions_1 = require("../../actions");
const reducer_1 = require("../../reducer");
const utils_1 = require("../utils");
function ApproveChargeFlowWrapper() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const handleStatusRouting = (0, utils_1.createStatusRouter)(history, dispatch, analytics, path);
    // Get token from query parameter
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    // Get approve charge flow data from Redux
    const approveChargeFlowData = (0, react_redux_1.useSelector)(reducer_1.selectors.approveChargeFlowData);
    // API call to get approve charge flow data
    const { data: apiData, isLoading, error, } = (0, consumer_applications_v2_api_1.useGetConsumerApplicationsV2ApproveChargeFlowsTokenQuery)({ token: token || '' }, { skip: !token || !!approveChargeFlowData } // Skip if no token or data already exists in Redux
    );
    (0, react_1.useEffect)(() => {
        // If we have API data and no data in Redux, store it
        if (apiData && !approveChargeFlowData) {
            dispatch((0, actions_1.setApproveChargeFlowData)(apiData));
        }
    }, [apiData, approveChargeFlowData, dispatch]);
    (0, react_1.useEffect)(() => {
        const flowData = approveChargeFlowData || apiData;
        if (flowData && 'status' in flowData && flowData.status) {
            handleStatusRouting(flowData);
        }
    }, [approveChargeFlowData, apiData, handleStatusRouting]);
    // Show error if no token provided
    if (!token) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "error-container", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Error" }), (0, jsx_runtime_1.jsx)(components_1.P, { children: "No token provided in URL parameters." })] }));
    }
    // Show loading state
    if (isLoading && !approveChargeFlowData) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "loading-container", children: (0, jsx_runtime_1.jsx)(components_1.Spinner, {}) }));
    }
    // Show error state
    if (error && !approveChargeFlowData) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "error-container", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Error" }), (0, jsx_runtime_1.jsx)(components_1.P, { children: "Unable to load approve and charge flow data." })] }));
    }
    // Show loading while determining route
    return ((0, jsx_runtime_1.jsx)("div", { className: "loading-container", children: (0, jsx_runtime_1.jsx)(components_1.Spinner, {}) }));
}
exports.default = ApproveChargeFlowWrapper;
